import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import notify from '../../utils/IANotification';
import AdminLayout from '../../layouts/AdminLayout'
import Switch from 'react-switch'
import { MdAdd } from 'react-icons/md';
import {
  fetch_breakfast_by_id,
  create_new_breakfast,
  update_breakfast_by_id,
  delete_breakfast_by_id
} from "../../api/cafeAPI";

export default function AdminCafeFormPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  let breakfast_id = new URLSearchParams(window.location.search).get("breakfast_id")

  const [breakfastData, setBreakfastData] = useState({
    name: "",
    is_selling: "1",
    menu: [], // {name, price, description}
    is_published: "0",
    datetime: new Date(),
  })

  const fetchBreakfastInformationById = async () => {
    if (!breakfast_id) return;
    let data = await fetch_breakfast_by_id(breakfast_id);
    if (data.status === 200) {
      setBreakfastData(data.data);
    } else {
      notify({ type: "error", message: data.message });
    }
  }

  useEffect(() => {
    fetchBreakfastInformationById()
  }, [])


  const createBreakfast = async () => {
    let data = await create_new_breakfast(breakfastData);
    if (data.status === 200) {
      notify({ type: "success", message: data.message });
      navigate("/admin/cafe/details?breakfast_id=" + data.data.id);
    } else {
      notify({ type: "error", message: data.message });
    }
  }

  const updateBreakfast = async () => {
    if (!breakfast_id) return;
    let data = await update_breakfast_by_id(breakfast_id, breakfastData);
    if (data.status === 200) {
      notify({ type: "success", message: data.message });
    } else {
      notify({ type: "error", message: data.message });
    }
  }

  const deleteEvent = async () => {
    if (!breakfast_id) return;
    let data = await delete_breakfast_by_id(breakfast_id);
    if (data.status === 200) {
      notify({ type: "success", message: data.message });
      navigate("/admin/cafe");
    } else {
      notify({ type: "error", message: data.message });
    }
  }

  return (
    <AdminLayout
      navSelected={"Cafe"}
      regularContainer={breakfast_id !== "new"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>
            {breakfast_id === "new" ? "New Breakfast" : "Edit Breakfast"}
          </h1>
          <div className="flex items-center gap-3">
            {breakfast_id !== "new" && (
              <button
                className="inline-flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200"
                onClick={deleteEvent}
              >
                Delete
              </button>
            )}
            <button
              className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200"
              onClick={() => {
                if (breakfast_id === "new") {
                  createBreakfast()
                } else {
                  updateBreakfast()
                }
              }}
            >
              {breakfast_id === "new" ? "Create" : "Save"}
            </button>
          </div>
        </>
      }
    >
      <div className="flex-row flex gap-2 alignStart">
        <div className="w-100">
          <div className="card">
            <p className="card-title">Breakfast Information</p>
            <div className="flex-row flex gap-2">
              <div className="column">
                <label htmlFor="name" className='input-label'>Name</label>
                <input type="text" id="name" className="text-input" value={breakfastData.name}
                  placeholder='Who is selling?'
                  onChange={(e) => {
                    setBreakfastData({
                      ...breakfastData,
                      name: e.target.value
                    })
                  }}
                />
              </div>
              <div className="flex-row items-center flex gap-2">
                <label htmlFor="is_selling" className='input-label'>Open</label>
                <Switch onChange={(checked) => {
                  setBreakfastData({
                    ...breakfastData,
                    is_selling: checked ? "1" : "0"
                  })
                }} checked={breakfastData.is_selling == "1"} />
              </div>
              <div className="flex-row items-center flex gap-2">
                <label htmlFor="is_selling" className='input-label'>Published</label>
                <Switch onChange={(checked) => {
                  setBreakfastData({
                    ...breakfastData,
                    is_published: checked ? "1" : "0"
                  })
                }} checked={breakfastData.is_published == "1"} />
              </div>
            </div>

            <div className="flex-row flex gap-2 mt-10">
              <div className="column w-100">
                <label htmlFor="datetime" className='input-label'>Date</label>
                <input type="datetime-local" id="datetime" className="text-input w-100" value={breakfastData.datetime}
                  onChange={(e) => {
                    setBreakfastData({
                      ...breakfastData,
                      datetime: e.target.value
                    })
                  }}
                />
              </div>
            </div>

            {/* Menu */}
            <div className="flex-row flex mt-4 items-center gap-2 justify-between">
              <h3>Menu</h3>
              <button className="backgroundLess flex-row items-center flex gap-2"
                onClick={() => {
                  let temp = [...breakfastData.menu]
                  temp.push({ name: "", price: 0, description: "" })
                  setBreakfastData({
                    ...breakfastData,
                    menu: temp
                  })
                }}
              >
                <MdAdd size={15} />
                Add</button>
            </div>

            {breakfastData?.menu?.length > 0 && breakfastData?.menu?.map((menu, index) => {
              return (
                <div key={index} className="mt-10" style={{ borderBottom: index + 1 !== breakfastData?.menu?.length && "2px solid gray", padding: 10, paddingBottom: 20, marginBottom: 20, }}>
                  <div className="flex-row flex justify-between items-center">
                    <p className='b'>Item #{index + 1}</p>
                    <button className="backgroundLess"
                      onClick={() => {
                        let temp = [...breakfastData.menu]
                        temp.splice(index, 1)
                        setBreakfastData({
                          ...breakfastData,
                          menu: temp
                        })
                      }}
                    >Delete</button>
                  </div>
                  <div className="flex-row flex gap-2">
                    <div className="column">
                      <label htmlFor="name" className='input-label'>Name</label>
                      <input type="text" id="name" className="text-input" value={menu.name}
                        placeholder='e.g. Roti Prata'
                        onChange={(e) => {
                          let temp = [...breakfastData.menu]
                          temp[index].name = e.target.value
                          setBreakfastData({
                            ...breakfastData,
                            menu: temp
                          })
                        }}
                      />
                    </div>
                    <div className="column">
                      <label htmlFor="price" className='input-label'>Price</label>
                      <input type="text" id="price" className="text-input" value={menu.price}
                        placeholder='e.g. 2.50'
                        onChange={(e) => {
                          let temp = [...breakfastData.menu]
                          temp[index].price = e.target.value
                          setBreakfastData({
                            ...breakfastData,
                            menu: temp
                          })
                        }}
                      />
                    </div>
                  </div>
                  <div className="column mt-10">
                    <label htmlFor="description" className='input-label'>Description</label>
                    <textarea id="description" className="textarea-input" value={menu.description}
                      placeholder='e.g. Comes with curry sauce'
                      onChange={(e) => {
                        let temp = [...breakfastData.menu]
                        temp[index].description = e.target.value
                        setBreakfastData({
                          ...breakfastData,
                          menu: temp
                        })
                      }}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </AdminLayout>
  )
}
